import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
const organize = ['What you observe', 'The context in which it happens', 'What you still need to know', 'Which explanations deserve consideration', 'What functional information you want to explore'];
export function FinalCTA() {
  return <section className="bg-brand-dark px-4 py-16 sm:py-24" data-id="element-117" data-mp="83m8vu0ujoyz">
      <div className="mx-auto max-w-3xl text-center" data-id="element-118" data-mp="m46pcjjah8pb">
        <h2 className="text-balance font-serif text-[30px] font-extrabold leading-tight text-white sm:text-[44px]" data-id="element-119" data-mp="m2vkege3xuwm">
          Ready to Organize Sensory Modulation Cases With a <em className="text-[#C9B8F5]" data-id="element-120" data-mp="vtgj03ts6zfj">Clearer Process?</em>
        </h2>
        <p className="mx-auto mt-5 max-w-2xl text-[17px] leading-relaxed text-white/75" data-id="element-121" data-mp="qveyrfkmcu2h">
          You don’t need another enormous collection of theory to search through whenever a case feels complicated. You need a practical way
          to organize:
        </p>
      </div>

      <ul className="mx-auto mt-8 max-w-xl space-y-2.5" data-id="element-122" data-mp="2c4ocezz2fd7s">
        {organize.map(o => <li key={o} className="flex items-center gap-3 rounded-2xl bg-white/10 px-4 py-4" data-id="element-123" data-mp="2h3rfwfzedbdn">
            <span className="grid h-8 w-8 shrink-0 place-items-center rounded-full bg-cta text-white" data-id="element-124" data-mp="2h5knbxhu3zmp">
              <CheckIcon className="h-5 w-5" aria-hidden="true" data-id="element-125" data-mp="2r1xgmu9gwbgx" />
            </span>
            <span className="text-[15px] font-extrabold uppercase tracking-wide text-white" data-id="element-126" data-mp="2qzuhnkqc7802">{o}</span>
          </li>)}
      </ul>

      <div className="mx-auto mt-10 max-w-2xl text-center text-[17px] leading-relaxed text-white/80" data-id="element-127" data-mp="3023p21qb6l98">
        <p data-id="element-128" data-mp="34ssjnpxabycl">
          Six premium volumes. More than 30 practical decision tools. Five professional bonuses. One structured educational framework you can
          return to whenever you need to organize your reasoning.
        </p>
        <p className="mt-6 font-serif text-[28px] font-extrabold leading-tight text-white sm:text-4xl" data-id="element-129" data-mp="3et2vp77l2zq6">
          Get Instant Access Today for Just <span className="text-amber-400" data-id="element-130" data-mp="1jocy0dxsczwj">$27</span>
        </p>
      </div>

      <CTAButton className="mt-8" tone="dark" label="Get the Sensory Modulation Clinical Pathway™" sublabel="Instant digital access · One-time payment · Lifetime access · 7-Day Guarantee" data-id="element-131" data-mp="1jolba6xtm789" />
    </section>;
}